/* eslint-disable */
import {
    Card,
    CardContent,
    Grid,
    RACRadio,
    Typography,
} from '@rentacenter/racstrap';
import React, { useContext, useEffect, useState } from 'react';
import { CostBasedPricingStyles } from '../Styles/CostBasedPricing';
import { ReactComponent as RightAngle } from '../../../assets/images/angleRight.svg';
import { PricingQueueContext } from './PricingQueueContext';

export default function ZoneBasedPricingApproval(props: any) {
    const classes = CostBasedPricingStyles();
    const {
        zoneBasedPricingApprovalData, setZoneBasedApprovalFormData,
        indexValue, setHideMainPage, comments, setComments, setIsPackage
    } = useContext(PricingQueueContext);

    const formatDate = (dateStr: string) => {
        const [year, month, day] = dateStr.split('-');
        return `${month}/${day}/${year}`;
    };
    function returnValue(value: string | null, type?: any) {
        return value ? `$${value}` : '-'
    }
    function returnDecimelValue(value: string | null, type?: any) {
        return value ? parseFloat(value).toString() : '-'
    }
    useEffect(() => {
        console.log(indexValue, 'indexValue in zoneBasedRules')
        if (indexValue && indexValue.zoneBasedRules) {
            const ruleData = indexValue.zoneBasedRules;
            const updatedData = {
                zoneNumber: ruleData.zone?.length ? ruleData.zone?.join(', ') : '-',
                departmentNumber: ruleData.departmentName || '-',
                subdepartmentNumber: ruleData.subdepartmentName || '-',
                bracketNumber: ruleData.bracketName || '-',
                termPrem: ruleData.termPrem || '-',
                turn: returnDecimelValue(ruleData.turn) || '-',
                reCalculateTerm: capitalizeFirstLetter(ruleData.recalculateTermFlag),
                newAndUsedRatePrem: returnValue(ruleData.newAndUsedRatePrem) || '-',
                brandNewRatePrem: returnValue(ruleData.brandNewRatePrem) || '-',
                startDate: formatDate(ruleData.startDate) || '-',
                endDate: formatDate(ruleData.endDate) || '-',
                publishPriceForExisitingRMS: ruleData.publishPriceFlag || '-',
                schedule: indexValue.schedule || '-'
            };
            setZoneBasedApprovalFormData(updatedData);
        }
    }, [])

    const capitalizeFirstLetter = (str: string): string => {
        if (!str) return '-';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    function breadCrums() {
        return (
            <>
                <Typography variant='body1' className={`${classes.greyColor} ${classes.fs12} ${classes.cursorStyle}`}>
                    <span onClick={() => {
                        setHideMainPage(false);
                        setComments('');
                        setIsPackage(false);
                    }}> Pricing Queue </span>
                    <span className={`${classes.ml10}`}><RightAngle className={`${classes.h10}`} style={{ color: 'grey' }} /></span>
                    <span className={`${classes.ml10} ${classes.cursorStyle} ${classes.textBlue}`}
                    > Zone Based Pricing Approval </span>
                </Typography>
            </>
        )
    }

    return (
        <>
            <Grid container md={12} className={`${classes.pagePadding1}`}>
                <Grid container md={12} style={{ marginBottom: '15px' }}>
                    {breadCrums()}
                </Grid>
                <Grid container style={{ width: '100%' }}>
                    <Grid container style={{ width: '49%', marginRight: '1%' }}>
                        <Grid item md={12} style={{ marginBottom: '10px' }}>
                            <Typography variant='h4'>Zone Based Pricing Approval</Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Card className={classes.card} style={{ height: '70vh', overflowY: 'auto' }}>
                                <CardContent style={{ paddingRight: '0px', padding: '3%' }}>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '15px' }}>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Zone</Typography>
                                            <Typography title={zoneBasedPricingApprovalData.zoneNumber?.length > 25 ? zoneBasedPricingApprovalData.zoneNumber : ''}
                                                style={{ fontFamily: 'OpenSans-regular' }}>
                                                {zoneBasedPricingApprovalData.zoneNumber?.length > 25 ? (zoneBasedPricingApprovalData.zoneNumber).slice(0, 25) + '...' : zoneBasedPricingApprovalData.zoneNumber}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Department</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.departmentNumber}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Sub Department</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.subdepartmentNumber}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '15px' }}>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Bracket</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.bracketNumber}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Start Date</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.startDate}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>End Date</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.endDate}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '15px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title6}>Do you want to generate new price for existing RMS items?</span>
                                            <span style={{ color: 'red', marginLeft: '5px' }}> * </span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={(zoneBasedPricingApprovalData?.publishPriceForExisitingRMS)?.toUpperCase() == 'YES'}
                                                    label="Yes (Generate new price to existing and future RMS items)"
                                                    name="existingRMS"
                                                    disabled={true}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={(zoneBasedPricingApprovalData?.publishPriceForExisitingRMS)?.toUpperCase() == 'NO'}
                                                    label="No (Generate new price only to future RMS items)"
                                                    name="existingRMS"
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '10px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title6}>How do you want to update the Zone Based Pricing?</span>
                                            <span style={{ color: 'red', marginLeft: '5px' }}> * </span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={zoneBasedPricingApprovalData?.schedule == 'IMMEDIATE'}
                                                    label="Immediately"
                                                    name="schedule"
                                                    disabled={true}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={zoneBasedPricingApprovalData?.schedule == 'OVERNIGHT'}
                                                    label="Overnight"
                                                    name="schedule"
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12}>
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <span className={classes.title6}>Comments</span>
                                            <Grid item>
                                                <textarea
                                                    rows={6}
                                                    style={{ resize: "none", width: "100%", border: "1px solid lightgray !important" }}
                                                    disabled={
                                                        indexValue?.status?.toUpperCase() == "QUEUED" ||
                                                            indexValue?.status?.toUpperCase() == "WAITING"
                                                            ? false
                                                            : true
                                                    }
                                                    value={comments}
                                                    onChange={(e: any) => {
                                                        setComments(e.target.value);
                                                    }}
                                                ></textarea>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid container style={{ width: '50%' }}>
                        <Grid item md={12} style={{ marginBottom: '10px' }}>
                            <Typography variant='h4'>Zone Based Foundation Rules</Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Card className={classes.card} style={{ height: '70vh', overflowY: 'auto' }}>
                                <CardContent style={{ paddingRight: '0px', padding: '3%' }}>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>New and Used Rate Prem</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.newAndUsedRatePrem}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Brand New Rate Prem</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.brandNewRatePrem}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Total Turns</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.turn}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Term Prem</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.termPrem}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Recalculate Term</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{zoneBasedPricingApprovalData.reCalculateTerm}</Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}
